(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-page-section"]) return;
  try {
    
  var acc = document.getElementsByClassName("accordion");
  var i;
  for (i = 0; i < acc.length; i++) {
  	acc[i].onclick = function() {
  		this.classList.toggle("active");
  		var panel = this.nextElementSibling;
  		if (panel.style.maxHeight){
  		panel.style.maxHeight = null;
  		} else {
  			panel.style.maxHeight = panel.scrollHeight + "px";
  		}
  	}
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-bar"]) return;
  try {
    

  const fetchData1 = () => {
    const value = $("#menu-search-input").val();
    const predictiveSearchSection = document.querySelector('.menu-search-results');
    var requestResponse;
    
    fetch(window.Shopify.routes.root + "search/suggest?q=" + value + "&resources[type]=product,collection,page&resources[options][unavailable_products]=hide&section_id=predictive-search")
      .then((response) => {
        requestResponse = response;
        return response.text();
       })
      .then((text) => {
        if (!requestResponse.ok) {
          throw new Error(`${requestResponse.status}: ${text}`);
        }
    
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
    
        predictiveSearchSection.innerHTML = resultsMarkup;
      })
      .catch((error) => {
        console.error(error);
      });
  }
  const fetchData2 = () => {
    const value = $("#nav-search-input").val();
    const predictiveSearchSection = document.querySelector('.predictive-search-results');
    var requestResponse;
    
    fetch(window.Shopify.routes.root + "search/suggest?q=" + value + "&resources[type]=product,collection,page,query&resources[options][unavailable_products]=hide&section_id=predictive-search")
      .then((response) => {
        requestResponse = response;
        return response.text();
       })
      .then((text) => {
        if (!requestResponse.ok) {
          throw new Error(`${requestResponse.status}: ${text}`);
        }
    
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
    
        predictiveSearchSection.innerHTML = resultsMarkup;
      })
      .catch((error) => {
        console.error(error);
      });
  }
  let timeId = 0
  $("#menu-search-input").on("input", function() {
    clearTimeout(timeId);
    timeId = setTimeout(() => fetchData1(), 500);
  })

  $("#menu-search-input").on("keydown", function(e) {
    console.log(e)
    if (e.key == "Enter" && !!$("#menu-search-input").val()) {
      window.location.href = '/search?q=' + $("#menu-search-input").val()
    }
  })
  
  $("#nav-search-input").on("input", function() {
    clearTimeout(timeId);
    timeId = setTimeout(() => fetchData2(), 500);
  })

  $("#nav-search-input").on("keydown", function(e) {
    console.log(e)
    if (e.key == "Enter" && !!$("#nav-search-input").val()) {
      window.location.href = '/search?q=' + $("#nav-search-input").val()
    }
  })
  
  $('.accordion-item').click(function(){
    if($(this).hasClass('accordion-show')) {
      $(this).removeClass('accordion-show')
    } else {
      $(this).addClass('accordion-show')
    }
  })
  const scrollBreakPoint = window.innerWidth * 0.8 - 74;
      document.addEventListener('scroll', e => {
        let height = $('.header-top').length > 0 && $('.header-top')[0].offsetHeight
        if (window.scrollY > height) {
          $('.header-container').addClass('header-sticky')
        } else {
          $('.header-container').removeClass('header-sticky')
        }

        if (window.scrollY > scrollBreakPoint) {
          $('.header-container').addClass('header-solid')
        } else if (!isMenuOpen) {
          $('.header-container').removeClass('header-solid')
        }
      })
      window.addEventListener('resize', e => {
        if(window.innerWidth > 990) {
          isMenuOpen = false;
          $('.close-menu').addClass('hidden')
          $('.open-menu').removeClass('hidden')
          if (window.scrollY <= scrollBreakPoint) {
            $('.header-container').removeClass('header-solid')
          }
        }
      })
      $('.drawer-nav .search-nav').on('wheel', function(e){e.stopPropagation()})
      $('.drawer-nav .cart-nav').on('wheel', function(e){e.stopPropagation()})

      $(document).ready(function() {
        $('.drawer').drawer({
          isScroll: {
            mouseWheel: true,
            preventDefault: false,
          },
        });
        $('.drawer').on('drawer.opened', function(){document.body.style.overflow = "hidden"});
        $('.drawer').on('drawer.closed', function(){document.body.style.overflow = "auto"});
        let height = $('.header-top').length > 0 && $('.header-top')[0].offsetHeight
        if (window.scrollY > height) {
          $('.header-container').addClass('header-sticky')
        } else {
          $('.header-container').removeClass('header-sticky')
        }
        if (window.scrollY > scrollBreakPoint) {
          $('.header-container').addClass('header-solid')
        } else if (!isMenuOpen) {
          $('.header-container').removeClass('header-solid')
        }
        fetchData3();
      });

      var isMenuOpen = false;

      $('.open-menu').on('click', () => {
        $('.open-menu').addClass('hidden')
        $('.close-menu').removeClass('hidden')
        $('.header-container').addClass('header-solid')
        isMenuOpen = true;
      })

      $('.close-menu > svg').on('click', () => {
        $('.close-menu').addClass('hidden')
        $('.open-menu').removeClass('hidden')
        if (window.scrollY <= 600) {
          $('.header-container').removeClass('header-solid')
        }
        isMenuOpen = false;
      })

      $('.cart-icon').on('click', () => {
        isMenuOpen = false
        $('.close-menu').addClass('hidden')
        $('.open-menu').removeClass('hidden')
        if (window.scrollY <= 600) {
          $('.header-container').removeClass('header-solid')
        }
      })

      $('.drawer-icon-search').on('click', () => {
        $('.drawer').drawer('open');
        $('.search-nav').removeClass('hide');
        $('.cart-nav').addClass('hide');
      })

      $('.drawer-icon-cart').on('click', () => {
        fetchData3();
        $('.drawer').drawer('open');
        $('.cart-nav').removeClass('hide');
        $('.search-nav').addClass('hide');
      })

  } catch(e) { console.error(e); }
})();
})();
